import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import { CgFileDocument, CgPhone, CgAwards } from "react-icons/cg";

function NavBar() {
  const [expanded, setExpanded] = useState(false);
  const [navColour, setNavColour] = useState(false);

  useEffect(() => {
    function scrollHandler() {
      setNavColour(window.scrollY >= 20);
    }
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
    setExpanded(false);
  };

  return (
    <Navbar
      expanded={expanded}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="navbar-logo">
          <span className="logo-accent">&lt;</span>
          Shahid Hussain
          <span className="logo-highlight"> | AI | Genai | Python </span>
          <span className="logo-accent">/&gt;</span>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => setExpanded(expanded ? false : "expanded")}
          className="custom-toggler"
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => scrollTo("home")} className="nav-item-link">
                <AiOutlineHome className="nav-icon" />
                <span>Home</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollTo("projects")} className="nav-item-link">
                <AiOutlineFundProjectionScreen className="nav-icon" />
                <span>Projects</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollTo("skills")} className="nav-item-link">
                <AiOutlineUser className="nav-icon" />
                <span>Skillset</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollTo("certifications")} className="nav-item-link">
                <CgAwards className="nav-icon" />
                <span>Certifications</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollTo("resume")} className="nav-item-link">
                <CgFileDocument className="nav-icon" />
                <span>Resume</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollTo("contacts")} className="nav-item-link">
                <CgPhone className="nav-icon" />
                <span>Contact</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .navbar {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          background: rgba(15, 23, 42, 0.8) !important;
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          padding: 18px 0;
          border-bottom: 1px solid rgba(51, 65, 85, 0.5);
        }
        
        .sticky {
          background: rgba(15, 23, 42, 0.98) !important;
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
          padding: 12px 0;
        }
        
        .navbar-logo {
          font-weight: 700;
          font-size: 1.4rem;
          font-family: 'SF Mono', 'Fira Code', monospace;
          color: #e2e8f0 !important;
          letter-spacing: -0.5px;
          white-space: nowrap;
        }
        
        .logo-accent {
          color: #3b82f6;
          margin: 0 2px;
        }
        
        .logo-highlight {
          color: #64748b;
          font-weight: 400;
          font-size: 0.9rem;
        }
        
        .navbar-logo:hover {
          text-shadow: 0 0 25px rgba(59, 130, 246, 0.5);
        }
        
        .navbar-logo:hover .logo-accent {
          text-shadow: 0 0 15px rgba(59, 130, 246, 0.9);
        }
        
        .nav-item-link {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #94a3b8 !important;
          font-size: 0.95rem;
          font-weight: 500;
          padding: 10px 14px !important;
          margin: 0 2px;
          position: relative;
          transition: all 0.3s ease;
          border-radius: 8px;
        }
        
        .nav-icon {
          font-size: 1.1rem;
          transition: all 0.3s ease;
        }
        
        .nav-item-link:hover {
          color: #e2e8f0 !important;
          background: rgba(59, 130, 246, 0.1);
        }
        
        .nav-item-link:hover .nav-icon {
          color: #3b82f6 !important;
          transform: translateY(-2px);
        }
        
        .nav-item-link.active {
          color: #3b82f6 !important;
          background: rgba(59, 130, 246, 0.15);
        }
        
        .nav-item-link.active .nav-icon {
          color: #3b82f6 !important;
        }
        
        .nav-item-link::after {
          content: '';
          position: absolute;
          bottom: 6px;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #3b82f6, #60a5fa);
          transition: all 0.3s ease;
          transform: translateX(-50%);
          border-radius: 2px;
        }
        
        .nav-item-link:hover::after {
          width: 25px;
        }
        
        .nav-item-link.active::after {
          width: 25px;
        }
        
        .custom-toggler {
          border: none;
          background: transparent;
          padding: 8px;
        }
        
        .custom-toggler span {
          display: block;
          width: 22px;
          height: 2px;
          background: #e2e8f0;
          margin: 5px 0;
          transition: all 0.4s ease;
          border-radius: 2px;
        }
        
        .custom-toggler:not(.collapsed) span:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }
        
        .custom-toggler:not(.collapsed) span:nth-child(2) {
          opacity: 0;
        }
        
        .custom-toggler:not(.collapsed) span:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }
        
        .navbar-toggler:focus {
          box-shadow: none;
        }
        
        @media (max-width: 768px) {
          .navbar-logo {
            font-size: 1.1rem;
          }
          
          .nav-item-link {
            padding: 14px 20px !important;
            margin: 4px 0;
            font-size: 1rem;
          }
          
          .nav-item-link::after {
            display: none;
          }
          
          .navbar-collapse {
            background: rgba(15, 23, 42, 0.98);
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
            margin: 16px -16px 0;
            padding: 16px;
            border-radius: 12px;
            border: 1px solid rgba(51, 65, 85, 0.5);
          }
        }
        
        @media (max-width: 576px) {
          .navbar-logo {
            font-size: 1rem;
            white-space: normal;
            line-height: 1.4;
          }
          
          .logo-highlight {
            display: none;
          }
        }
      `}</style>
    </Navbar>
  );
}

export default NavBar;